import { TemplateNodesDict } from 'src/exShared/types/types'

/**
 * 1つのひな形で検索キーを設定できる質問の最大数
 */
export const MAX_TRACE_KEYS_PER_TEMPLATE = 30

/**
 * ひな形ノードから検索キーのIDを収集する
 *
 * @param templateNodesDict ひな形ノードの辞書
 * @returns 検索キーIDの配列
 */
export const collectTraceKeyIds = (
  templateNodesDict: TemplateNodesDict,
): number[] => {
  return Object.values(templateNodesDict)
    .map(node => node?.traceKey?.traceKeyId)
    .filter((traceKeyId): traceKeyId is number => traceKeyId != null)
}

/**
 * ひな形ノードで使用されている検索キーの数を取得する
 *
 * @param templateNodesDict ひな形ノードの辞書
 * @returns 使用されている検索キーの数
 */
export const countTraceKey = (templateNodesDict: TemplateNodesDict): number => {
  return collectTraceKeyIds(templateNodesDict).length
}
